import { Injectable, inject } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';
import { SyncServiceAction, SyncServiceCommandResultDto } from './synchronization-center.model';

/** The write side of Synkroniseringscenteret; the state itself is an httpResource in the component. */
@Injectable({ providedIn: 'root' })
export class SynchronizationCenterService {
    private readonly http = inject(HttpService);

    /** The whole pool: new kørsler are stamped paused / queued from here on; resume also releases the paused ones. */
    async pauseQueuePool(): Promise<boolean> {
        return await this.http.get<boolean>(`${environment.adminConfig.apiUri}/queue/pause`);
    }

    async resumeQueuePool(): Promise<boolean> {
        return await this.http.get<boolean>(`${environment.adminConfig.apiUri}/queue/resume`);
    }

    /** Close or open one worker's intake through its /admin endpoint (#979 fase 2). */
    async serviceCommand(role: string, action: SyncServiceAction): Promise<SyncServiceCommandResultDto> {
        return await this.http.post<SyncServiceCommandResultDto, null>(`${environment.adminConfig.apiUri}/synccenter/service/${role}/${action}`, null);
    }
}
